<div class="filter-dialog">
    <div class="filter-dialog-header">

        <button class="close-btn" (click)="cancel()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="filter-dialog-body">
        <h3 class="title-filter">{{ 'activity.filter_by' | translate }}</h3>
        <div class="filter-field">
            <mat-form-field appearance="outline" class="filter-select-field">
                <mat-label>{{ 'menu_management.business_name' | translate }}</mat-label>
                <mat-select [(value)]="selectedBusinessName" panelClass="filter-select-panel">
                    <mat-option *ngFor="let name of filteredBusinessNames" [value]="name">{{ name }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="filter-field">
            <mat-form-field appearance="outline" class="filter-select-field">
                <mat-label>{{ 'menu_management.menu_name' | translate }}</mat-label>
                <mat-select [(value)]="selectedMenuName" panelClass="filter-select-panel">
                    <mat-option *ngFor="let name of filteredMenuNames" [value]="name">{{ name }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="filter-field">
            <mat-form-field appearance="outline" class="filter-select-field">
                <mat-label>{{ 'menu_management.address' | translate }}</mat-label>
                <mat-select [(value)]="selectedAddress" panelClass="filter-select-panel">
                    <mat-option *ngFor="let addr of filteredAddresses" [value]="addr">{{ addr }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="filter-field">
            <mat-form-field appearance="outline" class="filter-select-field">
                <mat-label>{{ 'menu_management.card_usernames' | translate }}</mat-label>
                <mat-select [(value)]="selectedCardUsernames" multiple panelClass="filter-select-panel">
                    <mat-option *ngFor="let username of data.filterOptions.cardUsernames" [value]="username">{{ username }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="filter-field">
            <mat-form-field appearance="outline" class="filter-select-field" [class.has-custom-range-value]="hasCustomRangeValue()">
                <mat-label>{{ 'activity.date' | translate }}</mat-label>
                <mat-select [(value)]="selectedDateRange" panelClass="filter-select-panel" (selectionChange)="onDateRangeTypeChange($event)">
                    <mat-option value="today">{{ 'menu_management.today' | translate }}</mat-option>
                    <mat-option value="week">{{ 'menu_management.this_week' | translate }}</mat-option>
                    <mat-option value="month">{{ 'menu_management.this_month' | translate }}</mat-option>
                    <mat-option value="custom" (click)="openCustomRangePicker()">{{ 'menu_management.custom_range' | translate }}</mat-option>
                </mat-select>
                <div class="custom-range-display-value" *ngIf="hasCustomRangeValue()">{{ getCustomRangeDisplayValue() }}</div>
            </mat-form-field>

            <div class="date-range-picker-hidden">
                <mat-form-field appearance="fill">
                    <mat-date-range-input [rangePicker]="customRangePicker">
                        <input matStartDate [(ngModel)]="customStartDate" [ngModelOptions]="{standalone: true}" [placeholder]="'subscription_plan_content.start_date' | translate">
                        <input matEndDate [(ngModel)]="customEndDate" [ngModelOptions]="{standalone: true}" [placeholder]="'subscription_plan_content.end_date' | translate">
                    </mat-date-range-input>
                    <mat-date-range-picker #customRangePicker>
                        <mat-date-range-picker-actions>
                            <button mat-button class="button-size-16" (click)="resetDateRange(customRangePicker)">{{ 'activity.reset' | translate }}</button>
                            <button mat-button class="button-size-16" matDateRangePickerApply>{{ 'activity.ok' | translate }}</button>
                        </mat-date-range-picker-actions>
                    </mat-date-range-picker>
                </mat-form-field>
            </div>
        </div>

        <div class="filter-field">
            <mat-form-field appearance="outline" class="filter-select-field">
                <mat-label>{{ 'menu_management.type' | translate }}</mat-label>
                <mat-select [(value)]="selectedType" panelClass="filter-select-panel">
                    <mat-option value="STANDARD">{{ 'menu_management.standard' | translate }}</mat-option>
                    <mat-option value="QUANTITY">{{ 'menu_management.quantity' | translate }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="filter-dialog-actions">
        <button class="reset-btn" (click)="resetFilters()">{{ 'activity.reset' | translate }}</button>
        <button class="apply-btn" (click)="applyFilter()">{{ 'activity.filter' | translate }}</button>
    </div>
</div>
